/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
  /**
   * ClassName to be applied to the alert
   */
  className?: string;
  /**
   * Label to be used in the `aria-labelledby` attribute
   */
  label?: string;
  /**
   * Navigation content
   */
  children: ReactNode;
  /**
   * Navigation display direction
   */
  direction?: 'row' | 'column';
}

export const Navigation = ({ className, label, children, direction = 'row' }: Props) => {
  const navClasses = classNames(
    className,
    {
      'lg:gap-x-4 xl:gap-x-6' : direction === 'row',
      'flex flex-col justify-center items-center gap-y-2 text-center': direction === 'column',
    }
  );

  return (
    <nav className={navClasses} aria-labelledby={label} data-cy='navbar'>
      {children}
    </nav>
  );
};
